<template>
    <div class="table-header">
       <div 
            v-for="(header, index) in headersComputed" :key="header" :style="{ width: widths[index] }"  
        >
            <p>{{ header }}</p>
       </div>
    </div>
</template>
<script>
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'

export default {
  name: 'TableHeader',
  props: {
    headers: Array,
    widths: Array,
    ignore: Array
  },
  setup(props) {
      const headersComputed = computed(() => props.headers.filter((header) => !props.ignore.includes(header) ));
      
      return {
          headersComputed
      }
  }
}
</script>
<style lang="scss">
.table-header {
  background: #EBF0F4;
  display: flex;
  padding: 16px 33px;

  p {
    /*font-family: 'lato-regular';*/
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #655D79;
    
  white-space: nowrap !important;
  word-break: keep-all !important;
  word-wrap: unset;
  }
}
</style>